// 公共
export const COM_NAV_STATUS = 'COM_NAV_STATUS'
export const COM_HEADER_STATUS = 'COM_HEADER_STATUS'
export const COM_LOADING_STATUS = 'COM_LOADING_STATUS'
// 显示toast
export const COM_SHOW_TOAST = 'COM_SHOW_TOAST'
// 显示成功toast
export const COM_SHOW_SUCCESS = 'COM_SHOW_SUCCESS'
// 显示失败toast
export const COM_SHOW_FAIL = 'COM_SHOW_FAIL'
// 显示toast文字
export const COM_TOAST_MSG = 'COM_TOAST_MSG'
export const COM_SHOW_ALERT = 'COM_SHOW_ALERT'
export const COM_ALERT_MSG = 'COM_ALERT_MSG'
// 显示timepicker
export const COM_SHOW_TIME_PICKER = 'COM_SHOW_TIME_PICKER'

// nav menu
export const FULL_NAV_MENU = 'FULL_NAV_MENU'
export const OPEN_NAV_MENU = 'OPEN_NAV_MENU'
export const CLOSE_NAV_MENU = 'CLOSE_NAV_MENU'
export const TOGGLE_NAV_MENU = 'TOGGLE_NAV_MENU'

// load
export const TRIGGER_LOAD_ANIMATION = 'TRIGGER_LOAD_ANIMATION'
export const TRIGGER_LOAD_ANIMATION_DONE = 'TRIGGER_LOAD_ANIMATION_DONE'
export const HIDE_LOAD_ANIMATION = 'HIDE_LOAD_ANIMATION'
export const REQUEST_FAILED = 'REQUEST_FAILED'

export const GET_TRAVELS_LIST = 'GET_TRAVELS_LIST'
export const GET_TRAVELS_SEARCH_KEY = 'GET_TRAVELS_SEARCH_KEY'
export const GET_TRAVELS_SCORLL_STATUS = 'GET_TRAVELS_SCORLL_STATUS'
export const GET_TRAVELS_PAGE_NUM = 'GET_TRAVELS_PAGE_NUM'



// WEBPACK FOOTER //
// ./src/vuexs/mutation-types.js